export default {
  RECENT: {
    value: '-published',
    label: 'RECENT',
  },
  COMMENTED: {
    value: '-popularity',
    label: 'COMMENTED',
  },
  RANDOM: {
    value: 'random',
    label: 'RANDOM',
  },
  UPVOTED: {
    value: '-votes',
    label: 'UPVOTED',
  },
  LEAST_EXPENSIVE: {
    value: 'budget',
    label: 'LEAST_EXPENSIVE',
  },
};
